import { SupportRequest } from "@/app/entities/SupportRequest";
import { httpClient } from "../http/httpClient";

export const claimNextSupportRequest = async () => {
  const {data} = await httpClient.post<SupportRequest>(`/support-requests/claim-next`).catch((error) => {
    throw new Error(error.response.data.message);
  });
  return data;
}